import { Button } from '@au/ui';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { Moon, Sun } from 'lucide-react';
import type { Theme } from './theme-storage';

interface ThemeToggleProps {
  theme: Theme;
  onToggle: () => void;
}

/**
 * Botón de acción, no un `Toggle` con `aria-pressed`: «presionado = claro» es ambiguo para un lector
 * de pantalla. Muestra el ícono del tema al que se va y el nombre dice la acción.
 */
export function ThemeToggle({ theme, onToggle }: ThemeToggleProps) {
  const { _ } = useLingui();
  const label = theme === 'light' ? _(msg`Cambiar a tema oscuro`) : _(msg`Cambiar a tema claro`);
  const Icon = theme === 'light' ? Moon : Sun;

  return (
    <Button icon variant="ghost" tone="info" size="sm" aria-label={label} onClick={onToggle}>
      <Icon size={18} aria-hidden />
    </Button>
  );
}
